<!-- ── New Customer Overlay Panel ──────────────────────────── -->
<div class="customer-panel-backdrop" *ngIf="customerDrawerOpen" (click)="closeCustomerDrawer()"></div>
<div class="customer-panel" [class.customer-panel--open]="customerDrawerOpen">
  <div class="drawer-header">
    <span class="drawer-title">New Customer</span>
    <button mat-icon-button (click)="closeCustomerDrawer()" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="drawer-body">
    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Name</mat-label>
      <input matInput [(ngModel)]="newCustomer.name" placeholder="Company / person name">
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Address</mat-label>
      <input matInput [(ngModel)]="newCustomer.address" placeholder="Address">
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>GST Number</mat-label>
      <input matInput [(ngModel)]="newCustomer.gstNumber" placeholder="e.g. 22AAAAA0000A1Z5">
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Contact Person</mat-label>
      <input matInput [(ngModel)]="newCustomer.contactPerson.name" placeholder="Contact name">
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Contact Email</mat-label>
      <input matInput type="email" [(ngModel)]="newCustomer.contactPerson.email" placeholder="email@example.com">
    </mat-form-field>

    <mat-form-field appearance="outline" class="form-field-full">
      <mat-label>Contact Phone</mat-label>
      <input matInput type="tel" [(ngModel)]="newCustomer.contactPerson.mobile" placeholder="+91 …">
    </mat-form-field>
  </div>

  <div class="drawer-actions">
    <button mat-stroked-button type="button" (click)="closeCustomerDrawer()">Cancel</button>
    <button mat-raised-button color="primary" type="button"
      [disabled]="!newCustomer.name"
      (click)="saveNewCustomer()">Save</button>
  </div>
</div>

<!-- ── Main form ────────────────────────────────────────────── -->
<div>
    <div class="plugin-form">

      <!-- Enquiry No -->
      <mat-form-field appearance="outline" class="form-field-full">
        <mat-label>Enquiry No. <span class="required-star">*</span></mat-label>
        <input matInput #enquiryIdInput [(ngModel)]="pluginData.enquiryId"
          placeholder="Enter Enquiry No" (blur)="onEnquiryIdBlur()" autocomplete="off">
        <mat-error *ngIf="!pluginData.enquiryId">Enquiry No. is required</mat-error>
        <mat-hint *ngIf="isDuplicateEnquiryId" class="duplicate-hint">This enquiry number is already in use</mat-hint>
      </mat-form-field>

      <!-- Customer Type -->
      <mat-form-field appearance="outline" class="form-field-full">
        <mat-label>Customer Type <span class="required-star">*</span></mat-label>
        <input matInput [matAutocomplete]="customerTypeAuto"
          [(ngModel)]="customerTypeSearch"
          (ngModelChange)="filterCustomerTypes($event)"
          placeholder="Select customer type…" autocomplete="off">
        <mat-autocomplete #customerTypeAuto (optionSelected)="onCustomerTypeSelected($event.option.value)">
          <mat-option *ngFor="let t of filteredCustomerTypes" [value]="t">{{ t }}</mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="!pluginData.customerDetails.customerType">Customer Type is required</mat-error>
      </mat-form-field>

      <!-- Customer Name -->
      <mat-form-field appearance="outline" class="form-field-full">
        <mat-label>Customer Name <span class="required-star">*</span></mat-label>
        <input matInput [matAutocomplete]="customerAuto"
          [(ngModel)]="customerSearch"
          (ngModelChange)="filterCustomers($event)"
          placeholder="Search customer…"
          autocomplete="new-customer-name"
          [attr.autocomplete]="'off'">
        <button matSuffix mat-icon-button type="button"
          (click)="openCustomerDrawer()" title="Add New Customer">
          <mat-icon>person_add</mat-icon>
        </button>
        <mat-autocomplete #customerAuto
          (optionSelected)="onCustomerSelected($event.option.value)">
          <mat-option *ngFor="let c of filteredCustomers" [value]="c">{{ c.name }}</mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="!pluginData.customerDetails.id">Customer is required</mat-error>
      </mat-form-field>

      <!-- GST + Contact Person (read-only: hydrated from customer) -->
      <div class="form-row-2">
        <mat-form-field appearance="outline">
          <mat-label>GST No.</mat-label>
          <input matInput [value]="pluginData.customerDetails.gstNumber" readonly placeholder="Auto-filled">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Contact Person</mat-label>
          <input matInput [value]="pluginData.customerDetails.contactPerson.name" readonly placeholder="Auto-filled">
        </mat-form-field>
      </div>

      <!-- Contact No + Email (read-only) -->
      <div class="form-row-2">
        <mat-form-field appearance="outline">
          <mat-label>Contact No.</mat-label>
          <input matInput type="tel" [value]="pluginData.customerDetails.contactPerson.mobile" readonly placeholder="Auto-filled">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Email ID</mat-label>
          <input matInput type="email" [value]="pluginData.customerDetails.contactPerson.email" readonly placeholder="Auto-filled">
        </mat-form-field>
      </div>

    </div>
</div>

